/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Directory_Submit_Ai_AutofillInputs */

const en_directory_submit_ai_autofill = /** @type {(inputs: Directory_Submit_Ai_AutofillInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`AI Autofill`)
};

const zh_directory_submit_ai_autofill = /** @type {(inputs: Directory_Submit_Ai_AutofillInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`AI Autofill`)
};

/**
* | output |
* | --- |
* | "AI Autofill" |
*
* @param {Directory_Submit_Ai_AutofillInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const directory_submit_ai_autofill = /** @type {((inputs?: Directory_Submit_Ai_AutofillInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Directory_Submit_Ai_AutofillInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_directory_submit_ai_autofill(inputs)
	return zh_directory_submit_ai_autofill(inputs)
});
export { directory_submit_ai_autofill as "directory.submit.ai_autofill" }